export const trainingTypeOptions = [
  'Altura GT1200',
  'Gemini Touch',
  'Instant Showcase',
];
